// source: accounts/protos/plan_dto.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */


var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.LicenseFirewallDTO', null, global);
goog.exportSymbol('proto.PlanFirewallDTO', null, global);
goog.exportSymbol('proto.PlansDTO', null, global);
goog.exportSymbol('proto.PriceFirewallDTO', null, global);
goog.exportSymbol('proto.PricesDTO', null, global);
goog.exportSymbol('proto.SubscriptionFirewallDTO', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.LicenseFirewallDTO = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.LicenseFirewallDTO, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.LicenseFirewallDTO.displayName = 'proto.LicenseFirewallDTO';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.SubscriptionFirewallDTO = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.SubscriptionFirewallDTO, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.SubscriptionFirewallDTO.displayName = 'proto.SubscriptionFirewallDTO';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.PriceFirewallDTO = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.PriceFirewallDTO, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.PriceFirewallDTO.displayName = 'proto.PriceFirewallDTO';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.PlanFirewallDTO = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.PlanFirewallDTO, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.PlanFirewallDTO.displayName = 'proto.PlanFirewallDTO';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.PricesDTO = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.PricesDTO.repeatedFields_, null);
};
goog.inherits(proto.PricesDTO, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.PricesDTO.displayName = 'proto.PricesDTO';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.PlansDTO = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.PlansDTO, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.PlansDTO.displayName = 'proto.PlansDTO';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.LicenseFirewallDTO.prototype.toObject = function(opt_includeInstance) {
  return proto.LicenseFirewallDTO.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.LicenseFirewallDTO} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.LicenseFirewallDTO.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    packageId: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
    invoiceId: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.LicenseFirewallDTO}
 */
proto.LicenseFirewallDTO.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.LicenseFirewallDTO;
  return proto.LicenseFirewallDTO.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.LicenseFirewallDTO} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.LicenseFirewallDTO}
 */
proto.LicenseFirewallDTO.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPackageId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setInvoiceId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.LicenseFirewallDTO.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.LicenseFirewallDTO.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.LicenseFirewallDTO} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.LicenseFirewallDTO.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.LicenseFirewallDTO.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.LicenseFirewallDTO} returns this
 */
proto.LicenseFirewallDTO.prototype.setId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.LicenseFirewallDTO} returns this
 */
proto.LicenseFirewallDTO.prototype.clearId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.LicenseFirewallDTO.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string package_id = 2;
 * @return {string}
 */
proto.LicenseFirewallDTO.prototype.getPackageId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.LicenseFirewallDTO} returns this
 */
proto.LicenseFirewallDTO.prototype.setPackageId = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.LicenseFirewallDTO} returns this
 */
proto.LicenseFirewallDTO.prototype.clearPackageId = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.LicenseFirewallDTO.prototype.hasPackageId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string invoice_id = 3;
 * @return {string}
 */
proto.LicenseFirewallDTO.prototype.getInvoiceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.LicenseFirewallDTO} returns this
 */
proto.LicenseFirewallDTO.prototype.setInvoiceId = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.LicenseFirewallDTO} returns this
 */
proto.LicenseFirewallDTO.prototype.clearInvoiceId = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.LicenseFirewallDTO.prototype.hasInvoiceId = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.SubscriptionFirewallDTO.prototype.toObject = function(opt_includeInstance) {
  return proto.SubscriptionFirewallDTO.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.SubscriptionFirewallDTO} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SubscriptionFirewallDTO.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    packageId: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
    invoiceId: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
    validSince: (f = msg.getValidSince()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    validUntil: (f = msg.getValidUntil()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    isCancelled: (f = jspb.Message.getBooleanField(msg, 6)) == null ? undefined : f,
    isTerminal: (f = jspb.Message.getBooleanField(msg, 7)) == null ? undefined : f,
    isActive: (f = jspb.Message.getBooleanField(msg, 8)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SubscriptionFirewallDTO}
 */
proto.SubscriptionFirewallDTO.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.SubscriptionFirewallDTO;
  return proto.SubscriptionFirewallDTO.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SubscriptionFirewallDTO} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SubscriptionFirewallDTO}
 */
proto.SubscriptionFirewallDTO.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPackageId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setInvoiceId(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setValidSince(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setValidUntil(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsCancelled(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsTerminal(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsActive(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.SubscriptionFirewallDTO.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.SubscriptionFirewallDTO.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SubscriptionFirewallDTO} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SubscriptionFirewallDTO.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getValidSince();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getValidUntil();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeBool(
      6,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeBool(
      7,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeBool(
      8,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.SubscriptionFirewallDTO.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.SubscriptionFirewallDTO} returns this
 */
proto.SubscriptionFirewallDTO.prototype.setId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SubscriptionFirewallDTO} returns this
 */
proto.SubscriptionFirewallDTO.prototype.clearId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SubscriptionFirewallDTO.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string package_id = 2;
 * @return {string}
 */
proto.SubscriptionFirewallDTO.prototype.getPackageId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.SubscriptionFirewallDTO} returns this
 */
proto.SubscriptionFirewallDTO.prototype.setPackageId = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SubscriptionFirewallDTO} returns this
 */
proto.SubscriptionFirewallDTO.prototype.clearPackageId = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SubscriptionFirewallDTO.prototype.hasPackageId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string invoice_id = 3;
 * @return {string}
 */
proto.SubscriptionFirewallDTO.prototype.getInvoiceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.SubscriptionFirewallDTO} returns this
 */
proto.SubscriptionFirewallDTO.prototype.setInvoiceId = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SubscriptionFirewallDTO} returns this
 */
proto.SubscriptionFirewallDTO.prototype.clearInvoiceId = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SubscriptionFirewallDTO.prototype.hasInvoiceId = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Timestamp valid_since = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.SubscriptionFirewallDTO.prototype.getValidSince = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.SubscriptionFirewallDTO} returns this
*/
proto.SubscriptionFirewallDTO.prototype.setValidSince = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SubscriptionFirewallDTO} returns this
 */
proto.SubscriptionFirewallDTO.prototype.clearValidSince = function() {
  return this.setValidSince(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SubscriptionFirewallDTO.prototype.hasValidSince = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Timestamp valid_until = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.SubscriptionFirewallDTO.prototype.getValidUntil = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.SubscriptionFirewallDTO} returns this
*/
proto.SubscriptionFirewallDTO.prototype.setValidUntil = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SubscriptionFirewallDTO} returns this
 */
proto.SubscriptionFirewallDTO.prototype.clearValidUntil = function() {
  return this.setValidUntil(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SubscriptionFirewallDTO.prototype.hasValidUntil = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional bool is_cancelled = 6;
 * @return {boolean}
 */
proto.SubscriptionFirewallDTO.prototype.getIsCancelled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.SubscriptionFirewallDTO} returns this
 */
proto.SubscriptionFirewallDTO.prototype.setIsCancelled = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SubscriptionFirewallDTO} returns this
 */
proto.SubscriptionFirewallDTO.prototype.clearIsCancelled = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SubscriptionFirewallDTO.prototype.hasIsCancelled = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional bool is_terminal = 7;
 * @return {boolean}
 */
proto.SubscriptionFirewallDTO.prototype.getIsTerminal = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.SubscriptionFirewallDTO} returns this
 */
proto.SubscriptionFirewallDTO.prototype.setIsTerminal = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SubscriptionFirewallDTO} returns this
 */
proto.SubscriptionFirewallDTO.prototype.clearIsTerminal = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SubscriptionFirewallDTO.prototype.hasIsTerminal = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional bool is_active = 8;
 * @return {boolean}
 */
proto.SubscriptionFirewallDTO.prototype.getIsActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.SubscriptionFirewallDTO} returns this
 */
proto.SubscriptionFirewallDTO.prototype.setIsActive = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.SubscriptionFirewallDTO} returns this
 */
proto.SubscriptionFirewallDTO.prototype.clearIsActive = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SubscriptionFirewallDTO.prototype.hasIsActive = function() {
  return jspb.Message.getField(this, 8) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.PriceFirewallDTO.prototype.toObject = function(opt_includeInstance) {
  return proto.PriceFirewallDTO.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.PriceFirewallDTO} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PriceFirewallDTO.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    packageId: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
    billingId: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
    currency: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
    amount: (f = jspb.Message.getOptionalFloatingPointField(msg, 5)) == null ? undefined : f,
    isActive: (f = jspb.Message.getBooleanField(msg, 6)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.PriceFirewallDTO}
 */
proto.PriceFirewallDTO.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.PriceFirewallDTO;
  return proto.PriceFirewallDTO.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.PriceFirewallDTO} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.PriceFirewallDTO}
 */
proto.PriceFirewallDTO.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPackageId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBillingId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setAmount(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsActive(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.PriceFirewallDTO.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.PriceFirewallDTO.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.PriceFirewallDTO} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PriceFirewallDTO.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeFloat(
      5,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeBool(
      6,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.PriceFirewallDTO.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.PriceFirewallDTO} returns this
 */
proto.PriceFirewallDTO.prototype.setId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.PriceFirewallDTO} returns this
 */
proto.PriceFirewallDTO.prototype.clearId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PriceFirewallDTO.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string package_id = 2;
 * @return {string}
 */
proto.PriceFirewallDTO.prototype.getPackageId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.PriceFirewallDTO} returns this
 */
proto.PriceFirewallDTO.prototype.setPackageId = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.PriceFirewallDTO} returns this
 */
proto.PriceFirewallDTO.prototype.clearPackageId = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PriceFirewallDTO.prototype.hasPackageId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string billing_id = 3;
 * @return {string}
 */
proto.PriceFirewallDTO.prototype.getBillingId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.PriceFirewallDTO} returns this
 */
proto.PriceFirewallDTO.prototype.setBillingId = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.PriceFirewallDTO} returns this
 */
proto.PriceFirewallDTO.prototype.clearBillingId = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PriceFirewallDTO.prototype.hasBillingId = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string currency = 4;
 * @return {string}
 */
proto.PriceFirewallDTO.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.PriceFirewallDTO} returns this
 */
proto.PriceFirewallDTO.prototype.setCurrency = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.PriceFirewallDTO} returns this
 */
proto.PriceFirewallDTO.prototype.clearCurrency = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PriceFirewallDTO.prototype.hasCurrency = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional float amount = 5;
 * @return {number}
 */
proto.PriceFirewallDTO.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.PriceFirewallDTO} returns this
 */
proto.PriceFirewallDTO.prototype.setAmount = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.PriceFirewallDTO} returns this
 */
proto.PriceFirewallDTO.prototype.clearAmount = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PriceFirewallDTO.prototype.hasAmount = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional bool is_active = 6;
 * @return {boolean}
 */
proto.PriceFirewallDTO.prototype.getIsActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.PriceFirewallDTO} returns this
 */
proto.PriceFirewallDTO.prototype.setIsActive = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.PriceFirewallDTO} returns this
 */
proto.PriceFirewallDTO.prototype.clearIsActive = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PriceFirewallDTO.prototype.hasIsActive = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.PlanFirewallDTO.prototype.toObject = function(opt_includeInstance) {
  return proto.PlanFirewallDTO.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.PlanFirewallDTO} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PlanFirewallDTO.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    packageId: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
    billingId: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
    paymentId: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
    isTrialing: (f = jspb.Message.getBooleanField(msg, 5)) == null ? undefined : f,
    trialUntil: (f = msg.getTrialUntil()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    license: (f = msg.getLicense()) && proto.LicenseFirewallDTO.toObject(includeInstance, f),
    subscription: (f = msg.getSubscription()) && proto.SubscriptionFirewallDTO.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.PlanFirewallDTO}
 */
proto.PlanFirewallDTO.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.PlanFirewallDTO;
  return proto.PlanFirewallDTO.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.PlanFirewallDTO} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.PlanFirewallDTO}
 */
proto.PlanFirewallDTO.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPackageId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBillingId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentId(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsTrialing(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTrialUntil(value);
      break;
    case 7:
      var value = new proto.LicenseFirewallDTO;
      reader.readMessage(value,proto.LicenseFirewallDTO.deserializeBinaryFromReader);
      msg.setLicense(value);
      break;
    case 8:
      var value = new proto.SubscriptionFirewallDTO;
      reader.readMessage(value,proto.SubscriptionFirewallDTO.deserializeBinaryFromReader);
      msg.setSubscription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.PlanFirewallDTO.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.PlanFirewallDTO.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.PlanFirewallDTO} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PlanFirewallDTO.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getTrialUntil();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getLicense();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.LicenseFirewallDTO.serializeBinaryToWriter
    );
  }
  f = message.getSubscription();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.SubscriptionFirewallDTO.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.PlanFirewallDTO.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.PlanFirewallDTO} returns this
 */
proto.PlanFirewallDTO.prototype.setId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.PlanFirewallDTO} returns this
 */
proto.PlanFirewallDTO.prototype.clearId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PlanFirewallDTO.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string package_id = 2;
 * @return {string}
 */
proto.PlanFirewallDTO.prototype.getPackageId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.PlanFirewallDTO} returns this
 */
proto.PlanFirewallDTO.prototype.setPackageId = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.PlanFirewallDTO} returns this
 */
proto.PlanFirewallDTO.prototype.clearPackageId = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PlanFirewallDTO.prototype.hasPackageId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string billing_id = 3;
 * @return {string}
 */
proto.PlanFirewallDTO.prototype.getBillingId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.PlanFirewallDTO} returns this
 */
proto.PlanFirewallDTO.prototype.setBillingId = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.PlanFirewallDTO} returns this
 */
proto.PlanFirewallDTO.prototype.clearBillingId = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PlanFirewallDTO.prototype.hasBillingId = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string payment_id = 4;
 * @return {string}
 */
proto.PlanFirewallDTO.prototype.getPaymentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.PlanFirewallDTO} returns this
 */
proto.PlanFirewallDTO.prototype.setPaymentId = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.PlanFirewallDTO} returns this
 */
proto.PlanFirewallDTO.prototype.clearPaymentId = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PlanFirewallDTO.prototype.hasPaymentId = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional bool is_trialing = 5;
 * @return {boolean}
 */
proto.PlanFirewallDTO.prototype.getIsTrialing = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.PlanFirewallDTO} returns this
 */
proto.PlanFirewallDTO.prototype.setIsTrialing = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.PlanFirewallDTO} returns this
 */
proto.PlanFirewallDTO.prototype.clearIsTrialing = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PlanFirewallDTO.prototype.hasIsTrialing = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.Timestamp trial_until = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.PlanFirewallDTO.prototype.getTrialUntil = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.PlanFirewallDTO} returns this
*/
proto.PlanFirewallDTO.prototype.setTrialUntil = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.PlanFirewallDTO} returns this
 */
proto.PlanFirewallDTO.prototype.clearTrialUntil = function() {
  return this.setTrialUntil(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PlanFirewallDTO.prototype.hasTrialUntil = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional LicenseFirewallDTO license = 7;
 * @return {?proto.LicenseFirewallDTO}
 */
proto.PlanFirewallDTO.prototype.getLicense = function() {
  return /** @type{?proto.LicenseFirewallDTO} */ (
    jspb.Message.getWrapperField(this, proto.LicenseFirewallDTO, 7));
};


/**
 * @param {?proto.LicenseFirewallDTO|undefined} value
 * @return {!proto.PlanFirewallDTO} returns this
*/
proto.PlanFirewallDTO.prototype.setLicense = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.PlanFirewallDTO} returns this
 */
proto.PlanFirewallDTO.prototype.clearLicense = function() {
  return this.setLicense(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PlanFirewallDTO.prototype.hasLicense = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional SubscriptionFirewallDTO subscription = 8;
 * @return {?proto.SubscriptionFirewallDTO}
 */
proto.PlanFirewallDTO.prototype.getSubscription = function() {
  return /** @type{?proto.SubscriptionFirewallDTO} */ (
    jspb.Message.getWrapperField(this, proto.SubscriptionFirewallDTO, 8));
};


/**
 * @param {?proto.SubscriptionFirewallDTO|undefined} value
 * @return {!proto.PlanFirewallDTO} returns this
*/
proto.PlanFirewallDTO.prototype.setSubscription = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.PlanFirewallDTO} returns this
 */
proto.PlanFirewallDTO.prototype.clearSubscription = function() {
  return this.setSubscription(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PlanFirewallDTO.prototype.hasSubscription = function() {
  return jspb.Message.getField(this, 8) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.PricesDTO.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.PricesDTO.prototype.toObject = function(opt_includeInstance) {
  return proto.PricesDTO.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.PricesDTO} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PricesDTO.toObject = function(includeInstance, msg) {
  var f, obj = {
    firewallList: jspb.Message.toObjectList(msg.getFirewallList(),
    proto.PriceFirewallDTO.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.PricesDTO}
 */
proto.PricesDTO.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.PricesDTO;
  return proto.PricesDTO.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.PricesDTO} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.PricesDTO}
 */
proto.PricesDTO.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.PriceFirewallDTO;
      reader.readMessage(value,proto.PriceFirewallDTO.deserializeBinaryFromReader);
      msg.addFirewall(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.PricesDTO.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.PricesDTO.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.PricesDTO} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PricesDTO.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFirewallList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.PriceFirewallDTO.serializeBinaryToWriter
    );
  }
};


/**
 * repeated PriceFirewallDTO firewall = 1;
 * @return {!Array<!proto.PriceFirewallDTO>}
 */
proto.PricesDTO.prototype.getFirewallList = function() {
  return /** @type{!Array<!proto.PriceFirewallDTO>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.PriceFirewallDTO, 1));
};


/**
 * @param {!Array<!proto.PriceFirewallDTO>} value
 * @return {!proto.PricesDTO} returns this
*/
proto.PricesDTO.prototype.setFirewallList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.PriceFirewallDTO=} opt_value
 * @param {number=} opt_index
 * @return {!proto.PriceFirewallDTO}
 */
proto.PricesDTO.prototype.addFirewall = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.PriceFirewallDTO, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.PricesDTO} returns this
 */
proto.PricesDTO.prototype.clearFirewallList = function() {
  return this.setFirewallList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.PlansDTO.prototype.toObject = function(opt_includeInstance) {
  return proto.PlansDTO.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.PlansDTO} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PlansDTO.toObject = function(includeInstance, msg) {
  var f, obj = {
    firewall: (f = msg.getFirewall()) && proto.PlanFirewallDTO.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.PlansDTO}
 */
proto.PlansDTO.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.PlansDTO;
  return proto.PlansDTO.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.PlansDTO} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.PlansDTO}
 */
proto.PlansDTO.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.PlanFirewallDTO;
      reader.readMessage(value,proto.PlanFirewallDTO.deserializeBinaryFromReader);
      msg.setFirewall(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.PlansDTO.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.PlansDTO.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.PlansDTO} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PlansDTO.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFirewall();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.PlanFirewallDTO.serializeBinaryToWriter
    );
  }
};


/**
 * optional PlanFirewallDTO firewall = 1;
 * @return {?proto.PlanFirewallDTO}
 */
proto.PlansDTO.prototype.getFirewall = function() {
  return /** @type{?proto.PlanFirewallDTO} */ (
    jspb.Message.getWrapperField(this, proto.PlanFirewallDTO, 1));
};


/**
 * @param {?proto.PlanFirewallDTO|undefined} value
 * @return {!proto.PlansDTO} returns this
*/
proto.PlansDTO.prototype.setFirewall = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.PlansDTO} returns this
 */
proto.PlansDTO.prototype.clearFirewall = function() {
  return this.setFirewall(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PlansDTO.prototype.hasFirewall = function() {
  return jspb.Message.getField(this, 1) != null;
};


goog.object.extend(exports, proto);
